var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDistribution(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1194.3215,
    height: 1194.3153,
    id: "svg992",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs928"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1542,
    y: 439,
    width: 1601,
    height: 1461,
    id: "rect883"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1543,
    y: 440,
    width: 1598,
    height: 1459,
    id: "rect886"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1543,
    y: 440,
    width: 1598,
    height: 1459,
    id: "rect889"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1543,
    y: 440,
    width: 1598,
    height: 1459,
    id: "rect892"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1543,
    y: 440,
    width: 1598,
    height: 1459,
    id: "rect895"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1543,
    y: 440,
    width: 1598,
    height: 1459,
    id: "rect898"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1543,
    y: 440,
    width: 1598,
    height: 1459,
    id: "rect901"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1543,
    y: 440,
    width: 1599,
    height: 1460,
    id: "rect904"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1543,
    y: 440,
    width: 1599,
    height: 1460,
    id: "rect907"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip9"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1543,
    y: 440,
    width: 1599,
    height: 1460,
    id: "rect910"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip10"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1543,
    y: 440,
    width: 1599,
    height: 1460,
    id: "rect913"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip11"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1543,
    y: 440,
    width: 1599,
    height: 1460,
    id: "rect916"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip12"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1543,
    y: 440,
    width: 1599,
    height: 1460,
    id: "rect919"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip13"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1543,
    y: 440,
    width: 1599,
    height: 1460,
    id: "rect922"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip14"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1543,
    y: 440,
    width: 1599,
    height: 1460,
    id: "rect925"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)",
    id: "g934",
    transform: "translate(-1745.4952,-572.45135)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 2342.66,581.618 c 324.73,0 587.99,263.253 587.99,587.992 0,324.74 -263.26,587.99 -587.99,587.99 v -587.99 z",
    stroke: "#ffffff",
    strokeWidth: 18.3333,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "#3d88fb",
    fillRule: "evenodd",
    id: "path932"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)",
    id: "g938",
    transform: "translate(-1745.4952,-572.45135)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 2342.66,1757.6 c -188.22,0 -365.07,-90.11 -475.7,-242.38 l 475.7,-345.61 z",
    stroke: "#ffffff",
    strokeWidth: 18.3333,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "#5637c8",
    fillRule: "evenodd",
    id: "path936"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)",
    id: "g942",
    transform: "translate(-1745.4952,-572.45135)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1866.96,1515.22 c -110.63,-152.27 -141.68,-348.3 -83.52,-527.311 l 559.22,181.701 z",
    stroke: "#ffffff",
    strokeWidth: 18.3333,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "#9116cd",
    fillRule: "evenodd",
    id: "path940"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4)",
    id: "g946",
    transform: "translate(-1745.4952,-572.45135)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1783.44,987.909 c 38.37,-118.094 113.15,-221.009 213.6,-293.995 l 345.62,475.696 z",
    stroke: "#ffffff",
    strokeWidth: 18.3333,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "#bb1ac9",
    fillRule: "evenodd",
    id: "path944"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5)",
    id: "g950",
    transform: "translate(-1745.4952,-572.45135)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1997.04,693.914 c 49.92,-36.267 105.24,-64.452 163.92,-83.518 l 181.7,559.214 z",
    stroke: "#ffffff",
    strokeWidth: 18.3333,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "#00d89e",
    fillRule: "evenodd",
    id: "path948"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6)",
    id: "g954",
    transform: "translate(-1745.4952,-572.45135)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 2160.96,610.396 c 58.68,-19.067 119.99,-28.778 181.7,-28.778 v 587.992 z",
    stroke: "#ffffff",
    strokeWidth: 18.3333,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "#fc3352",
    fillRule: "evenodd",
    id: "path952"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip7)",
    id: "g960",
    transform: "translate(-1745.4952,-572.45135)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 2100,1162 c 0,-130.89 106.33,-237 237.5,-237 131.17,0 237.5,106.11 237.5,237 0,130.89 -106.33,237 -237.5,237 -131.17,0 -237.5,-106.11 -237.5,-237 z",
    fill: "#ffffff",
    fillRule: "evenodd",
    id: "path958"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip8)",
    id: "g964",
    transform: "translate(-1745.4952,-572.45135)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 2156,1164 c 0,-99.41 80.59,-180 180,-180 99.41,0 180,80.59 180,180 0,99.41 -80.59,180 -180,180 -99.41,0 -180,-80.59 -180,-180 z",
    fill: "#d3e9e6",
    fillRule: "evenodd",
    id: "path962"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip9)",
    id: "g968",
    transform: "translate(-1745.4952,-572.45135)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 2100,1162 c 0,-130.89 106.33,-237 237.5,-237 131.17,0 237.5,106.11 237.5,237 0,130.89 -106.33,237 -237.5,237 -131.17,0 -237.5,-106.11 -237.5,-237 z",
    fill: "#ffffff",
    fillRule: "evenodd",
    id: "path966"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip10)",
    id: "g972",
    transform: "translate(-1745.4952,-572.45135)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 2156,1164 c 0,-99.41 80.59,-180 180,-180 99.41,0 180,80.59 180,180 0,99.41 -80.59,180 -180,180 -99.41,0 -180,-80.59 -180,-180 z",
    fill: "#d3e9e6",
    fillRule: "evenodd",
    id: "path970"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip11)",
    id: "g976",
    transform: "translate(-1745.4952,-572.45135)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 2100,1162 c 0,-130.89 106.33,-237 237.5,-237 131.17,0 237.5,106.11 237.5,237 0,130.89 -106.33,237 -237.5,237 -131.17,0 -237.5,-106.11 -237.5,-237 z",
    fill: "#ffffff",
    fillRule: "evenodd",
    id: "path974"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip12)",
    id: "g980",
    transform: "translate(-1745.4952,-572.45135)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 2156,1164 c 0,-99.41 80.59,-180 180,-180 99.41,0 180,80.59 180,180 0,99.41 -80.59,180 -180,180 -99.41,0 -180,-80.59 -180,-180 z",
    fill: "#d3e9e6",
    fillRule: "evenodd",
    id: "path978"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip13)",
    id: "g984",
    transform: "translate(-1745.4952,-572.45135)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 2100,1162 c 0,-130.89 106.33,-237 237.5,-237 131.17,0 237.5,106.11 237.5,237 0,130.89 -106.33,237 -237.5,237 -131.17,0 -237.5,-106.11 -237.5,-237 z",
    fill: "#ffffff",
    fillRule: "evenodd",
    id: "path982"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip14)",
    id: "g988",
    transform: "translate(-1745.4952,-572.45135)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 2156,1164 c 0,-99.41 80.59,-180 180,-180 99.41,0 180,80.59 180,180 0,99.41 -80.59,180 -180,180 -99.41,0 -180,-80.59 -180,-180 z",
    fill: "#d3e9e6",
    fillRule: "evenodd",
    id: "path986"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDistribution);
export default __webpack_public_path__ + "static/media/distribution.380b2ce15bcfaa12a0a62c135778f82b.svg";
export { ForwardRef as ReactComponent };